// extracted by mini-css-extract-plugin
export default {"LinkableContentLinkContent":"LinkableContent_LinkableContentLinkContent__+UhR1"};